import ET3Div from "../../../../core/et3-div"
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render"
import ClientPageType from "../client-page-type"
import Filter from "../filter"


export const Header = withLiteObserverAndTheme(() => {
    return (
        <ET3Div
            width={1510}
            height={150}
            alignItems={"flex-start"}
            fDirection={"row"}
            style={{}}
            color={""}
            justifyContent={"flex-start"}
            withShadow={false}
            isExtendable={true}
            isScrollable={false}
            onClick={() => { }}
        >
            <Filter />
            <ClientPageType />
        </ET3Div>
    )
})


export default Header